module.exports = __webpack_public_path__ + "static/img/gywm_ct.e72bc60c.png";